import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwiperComponent, SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-smash-swipper',
  templateUrl: './smash-swipper.component.html',
  styleUrls: ['./smash-swipper.component.scss']
})
export class SmashSwipperComponent implements OnInit, AfterViewInit {

  @Input() index: number;
  @Input() config: SwiperConfigInterface;

  @Output() indexChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() reachedEnd: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;

  actualIndex: number;

  ngOnInit() {
    this.actualIndex = this.index;
  }

  ngAfterViewInit() { }

  onIndexChange(_index: number): void {
    if (this.actualIndex > _index) {
      this.indexChanged.emit({ direction: 'left', index: _index });
    } else if (this.actualIndex < _index) {
      this.indexChanged.emit({ direction: 'right', index: _index });
    }
    this.actualIndex = _index;
  }

  onReachEnd() {
    this.reachedEnd.emit('reachEnd');
  }

}
